import { homeFindings, type HomeInsight } from "../homeShellData";
import HomeInsightCard from "./homeInsightCard";
import HomeTextAction from "./homeTextAction";
import { HomeSectionBody, HomeSectionHeader, type HomeSectionStatus } from "./homeSection";

type SovraHasFoundProps = {
    status?: HomeSectionStatus;
    findings?: HomeInsight[];
    opportunities?: HomeInsight[];
};

const formatIssueSummary = (count: number): string => (
    count === 1 ? "1 issue needs your attention" : `${count} issues need your attention`
);

const formatOpportunitySummary = (count: number): string => (
    count === 1 ? "1 opportunity identified" : `${count} opportunities identified`
);

const HomeSovraHasFound = ({
    status = "ready",
    findings = homeFindings
}: SovraHasFoundProps) => {
    const hasContent = findings.length > 0;
    const homeOpportunitiesCount = findings.filter(f => f.type === "opportunity").length;
    const subtitle = status === "ready" && hasContent
        ? `${formatIssueSummary(findings.length - homeOpportunitiesCount)} · ${formatOpportunitySummary(homeOpportunitiesCount)}`
        : undefined;

    return (
        <section aria-labelledby="sovra-has-found-heading">
            <HomeSectionHeader
                strong
                title="Sovra has found"
                titleId="sovra-has-found-heading"
                subtitle={subtitle}
                action={<HomeTextAction>View all insights</HomeTextAction>}
            />
            <HomeSectionBody
                status={status}
                hasContent={hasContent}
                loadingLabel="Loading what Sovra has found..."
                emptyLabel="Sovra has not identified any issues that need your attention."
                errorLabel="Unable to load what Sovra has found."
                skeletonCount={3}
            >
                <div className="d-flex flex-column gap-3">
                    {findings.map(finding => (
                        <HomeInsightCard key={finding.id} insight={finding} />
                    ))}
                </div>
            </HomeSectionBody>
        </section>
    );
};

export default HomeSovraHasFound;
